<template>
  <div class="filternone">
    <MedicalPopup
      :isActive="isDetailsActive"
      :selectedMedical="selectedMedical"
      @close="toggleDetails"
    />
    <div class="relative">
      <div class="absolute top21rem left-0 mob-hidden">
        <img
          src="../../../../assets/images/bg-des/bgd6.svg"
          alt="bg-polygon"
          class="h-full"
        />
      </div>
      <!-- <div class="bg-design-medc-dots absolute mob-hidden">
        <img
          src="../../../../assets/images/caregiver/medc-dots.svg"
          alt="bg-polygon"
          class="h-full"
        />
      </div> -->
      <!-- <div class="bg-design-mc-ecli absolute mob-hidden">
        <img
          src="../../../../assets/images/caregiver/ecli.svg"
          alt="bg-polygon"
          class="h-full"
        />
      </div> -->
      <div class="lg:w-4/5 w-full px-6 lg:px-0 mx-auto pt-4">
        <div class="flex justify-between items-center">
          <p
            class="title sm-fsize16 lg:font-medium md:font-medium font-bold pb-4"
          >
            Top Categories
          </p>
          <!-- <base-button
            outline
            type="primary"
            class="
              md:px-10
              lg:px-10
              px-6
              md:py-2
              lg:py-2
              py-1
              fs16700
              border-2
              mx-auto
            "
            @click="handleClick('e-all-categories')"
            >View more</base-button
          > -->
        </div>
        <!-- <p class="subtitle pt-2 lh32px sm-fsize14 bg-white">
          Home-based care could be long-term or short term depending on the
          ailment and needs of the patient. And it can prove challenging for a
          family caregiver
        </p> -->

        <div
          class="grid md:grid-cols-2 lg:grid-cols-3 grid-cols-1 grid-rows-2 md:gap-6 lg:gap-6 gap-4"
        >
          <div
            class="md:p-8 lg:p-8 p-4 h-fit card2bg md:rounded-2xl lg:rounded-2xl rounded-lg cursor-pointer"
            v-for="(item, index) in categoriesData"
            :key="index"
            :style="{ 'background-color': item.color }"
            @click="catData('product-all', item)"
          >
            <img
              :src="$imageURL + '/' + item.image"
              class="w-auto m-auto md:h-44 lg:h-44 h-24"
              alt="medical condition"
            />
            <p class="pt-5 mc-title fsize18-14px cursor-pointer text-center">
              {{ item.name }}
            </p>
            <p
              v-html="item.description"
              class="mc-subtitle fsize14-14px cursor-pointer html1 line-none-ul pt-2 ellipsis-3 cursor-pointer"
              @click="toggleDetails(true, item)"
            ></p>
            <!-- {{ item.description }} -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MedicalPopup from "./MedicalPopup.vue";

export default {
  components: {
    MedicalPopup,
  },
  data() {
    return {
      selectedMedical: {},
      isDetailsActive: false,
      medicalcards: [
        {
          id: "01",
          text: "Dementia",
          description:
            "Dementia is a generic term for the impaired ability to remember, think, or make decisions. This often interferes with doing everyday activities. Dementia can be of various types, Alzheimer’s being the most common one. The symptoms include- experiencing memory loss, facing difficulty in finding words, difficulty with reasoning or problem-solving, disorientation, repeated speech or actions, apathy. Many patients go through noticeable personality changes.",
          img: require("../../../../assets/images/caregiver/med-c1.svg"),
          color: "#f1f1f199",
        },
        {
          id: "02",
          text: "Cancer",
          description:
            "Our bodies are made with billions of cells. When these cells are abnormal or get old, they usually die. Cancer starts with a malfunction of cells when the old or abnormal ones don't die even after new cells are formed. In this way the cancer cells crowd the normal ones, and our body finds it difficult to function.Cancer diagnosis causes complex feelings and lifestyle changes that can be overwhelming for many families. Cancer has a debilitating impact on physical needs including energy, appetite and general well-being and it is often emotionally and financially draining for the majority.",
          img: require("../../../../assets/images/caregiver/med-c2.svg"),
          color: "#e3ceff66",
        },
        {
          id: "03",
          text: "ALS",
          description:
            "ALS (Lou Gehrig’s disease), or Amyotrophic Lateral Sclerosis, belongs to a wider group of disorders known as motor neuron diseases. It is a neurodegenerative disorder that affects nerve cells in the brain and the spinal cord. This progressive disease affects the nerve cells (neurons) responsible for controlling voluntary muscle movement. Voluntary muscles produce movements like chewing, walking, talking, moving, and even breathing. Currently, there is no cure for ALS, and neither is there any effective treatment to halt or reverse the progression of the disease.",
          img: require("../../../../assets/images/caregiver/med-c3.svg"),
          color: "#f1f1f199",
        },
        // {
        //   id: "04",
        //   text: "Mental Illness",
        //   description:
        //     "Mental health includes our emotional, psychological, and social well-being. Any disturbance or malfunction in these well-being leads to poor mental health. Several factors can contribute to risk for mental illness like trauma, history of abuse, ongoing medical conditions, biological factors or chemical imbalances in the brain. Effective treatments can include medication, therapies, psycho-social support, avoidance of risk factors such as consuming alcohol and other drug abuse and learning self-management skills to cope with various challenges.",
        //   img: require("../../../../assets/images/caregiver/med-c4.svg"),
        //   color: "#e3ceff66",
        // },
        // {
        //   id: "05",
        //   text: "Geriatric",
        //   description:
        //     "Geriatric care is a general term describing the management of healthcare for older adults. Achieving and maintaining optimal health and wellness for older adults is more than a matter of just medicine. Both healthcare professionals and caregivers come together to manage health conditions and provide a safe, positive environment for the senior citizens of our society. In addition to treating disease specific conditions, there are other risks including delirium, age related dementia, falls, incontinence and negative interactions between medications. Geriatric care is hence important for the older adults to lead a good quality life.",
        //   img: require("../../../../assets/images/caregiver/als.svg"),
        //   color: "#f1f1f199",
        // },
        // {
        //   id: "06",
        //   text: "Covid",
        //   description:
        //     "COVID-19 is an infectious disease caused by the SARS-CoV-2 virus. Most people infected with the virus experience mild to moderate respiratory illness and recover without requiring special treatment. However, some become seriously ill and require medical attention. Aged population and those with underlying medical conditions like cardiovascular disease, diabetes, chronic respiratory disease, or cancer are more likely to develop serious illness. COVID-19 symptoms include cough, fever or chills, shortness of breath or difficulty breathing, loss of taste or smell, muscle or body aches, sore throat, diarrhea, headache, nausea or vomiting, and congestion or runny nose. Getting vaccinated for Covid is essential.",
        //   img: require("../../../../assets/images/caregiver/covid19new.svg"),
        //   color: "#e3ceff66",
        // },
      ],
      categoriesData: [],
    };
  },
  methods: {
    toggleDetails(val = false, item = {}) {
      this.isDetailsActive = val;
      this.selectedMedical = item;
    },
    handleClick(name) {
      this.$router.push({ name: name });
      // this.toggleNavbar();
    },
    async getCategories() {
      const { data } = await this.$store.dispatch("eLearning/getCategories", {
        limit: 6,
      });
      // console.log(data);
      this.categoriesData = data;
    },
    catData(name, item) {
      this.$router.push({ name: name, query: { category: item._id } });
      // this.$store.commit("eLearning/selectedCat", item);
    },
  },
  mounted() {
    this.getCategories();
  },
};
</script>
<style>
.html1 > p {
  margin-bottom: 10px;
  /* overflow: hidden; */
  /* display: none; */
  /* text-overflow: ellipsis;
  overflow: hidden; */
}
.ql-align-justify {
  color: #777777;
}
</style>
